import {
	ILevel_CMSMetadata,
	ILevelStep_CMSMetadata,
	ILevelStepSection_CMSMetadata
} from "../../interfaces";

export function level3_CMS() {
	return _level3_CMS;
}

let _level3_CMS: ILevel_CMSMetadata = {
	level_number: 3,

	steps: [
		{
			step_name: "Program",
			step_title: "Program Information",
			step_description: "",
			sections: [
				{
					name: "programinfo",
					title: "",
					description: "",
					questions: [
						{
							name: "stateclassification",
							title: "",
							description: `According to local or state classifications, what is your hospital considered?`,
							dataSet: [
								{ Key: "Urban", Value: 1 },
								{ Key: "Suburban", Value: 2 },
								{ Key: "Rural", Value: 3 },
								{ Key: "Unsure", Value: 4 }
							]
						},

						{
							name: "residencyprograms",
							title: "",
							description: `From the list below, select all types of trainees in your emergency department`,
							dataSet: [
								{ Key: "Emergency medicine residents", Value: 1 },
								{ Key: "Non-emergency medicine residents", Value: 2 },
								{ Key: "Medical students", Value: 3 },
								{ Key: "Physician assistant/nurse practitioner students", Value: 4 },
								{ Key: "Pharmacy students", Value: 5 },
								{ Key: "No trainees", Value: 6 },
								{ Key: "Other", Value: 7 }
							]
						},


						{
							name: "edbeds",
							title: "",
							description: `How many treatment spaces do you have in your ED?`,
							dataSet: [
								{ Key: "0-5", Value: 1 },
								{ Key: "6-10", Value: 2 },
								{ Key: "11-25", Value: 3 },
								{ Key: "26-50", Value: 4 },
								{ Key: "51+", Value: 5 }
							]
						},

						{
							name: "edvisits",
							title: "",
							description: `How many patient ED visits for the most recent year?`,
							dataSet: [
								{ Key: "less than 15,000", Value: 1 },
								{ Key: "15,001 to 30,000", Value: 2 },
								{ Key: "30,001 to 50,000", Value: 3 },
								{ Key: "50,001 to 100,000", Value: 4 },
								{ Key: "greater than 100,000", Value: 5 }
							]
						},

						{
							name: "interestedwhy",
							title: "",
							description: `Why you are interested in PACED accreditation? (Check all that apply)`,
							dataSet: [
								{ Key: "Administrative mandate", Value: 1 },
								{ Key: "Improved patient care", Value: 2 },
								{
									Key: "ED Director/Staff initiative",
									Value: 3
								},
								{
									Key: "Community engagement",
									Value: 4
								},
								{
									Key: "Population health",
									Value: 5
								},
								{
									Key: "Marketing",
									Value: 6
								},
								{ Key: "Other", Value: 7 }
							]
						}
					]
				}
			]
		},
		{
			step_name: "Leadership",
			step_title: "Leadership and Collaboration",
			step_description:
				"",
			sections: [
				{
					name: "teamLeader",
					title:
						"Team Leader",
					description: "",
					questions: []
				},

				{
					name: "teamMember",
					title:
						"Team Member",
					description: "",
					questions: []
				},
				{
					name: "collabEngagement",
					title:
						"Collaboration and Engagement - Pain Control",
					description: "Programs shall be able to describe the implementation of ongoing processes and definitive follow-up plans occurring in the ED and whom (from outside the ED) is involved in addressing follow-up for continuity of care for patients with pain.",
					questions: []
				},
				{
					name: "followUp",
					title:
						"Describe how your ED initiates outpatient follow up, including the coordination of care of the chronic pain patient in the community.",
					description: "",
					questions: []
				},
				{
					name: "collaboration",
					title:
						"If applicable, describe collaboration among team members not in the ED (e.g. pharmacy, nursing, PT, administration) including how and what information is shared among the team.",
					description: "",
					questions: []
				},
				{
					name: "chronicPain",
					title:
						"If applicable, describe your plan to educate and train your team members in the following areas of your pain management program:  acute pain management, alternatives to opioids, " +
						"injection of inhalation treatments, and non-pharmacologic pain management treatments.",
					description: "",
					questions: []
				},
				{
					name: "oudPain",
					title:
						"If applicable, describe plans to educate your team in managing pain in patients with Opioid Use Disorder (OUD) with a focus on integration of non-stigmatizing language. ",
					description: "",
					questions: []
				},

				{
					name: "aud",
					title:
						"Collaboration and Engagement - Alcohol Use Disorder (AUD)",
					description: "Programs shall describe the implementation of ongoing processes and organized follow-up plans occurring in the ED and community resources responsible for follow-up of patients identified as having alcohol use disorder.",
					questions: []
				},

				{
					name: "aud_commresources",
					title:
						"Describe community resources available for follow-up and how your ED initiates outpatient follow-up including the coordination of care in patients with AUD.",
					description: "",
					questions: []
				},


				{
					name: "audfiles",
					title:
						"",
					description: "",
					questions: [
						{
							name: "level3_Leadership_aud_screening_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				},


				{
					name: "minutes",
					title:
						"Meetings",
					description: "Upload a summary of actions (may include goals, progress, summary of meetings with colleagues, staff education efforts, information sharing, etc.).",
					questions: [
						{
							name: "level3_Leadership_Summary_of_Actions_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				}
			]
		},

		{
			step_name: "PainManagement",
			step_title: "Pain Management",
			step_description: "Implement multimodal strategies for acute non-complicated pain based on best practice guidelines.  May include special population protocols such as geriatric pain and/or pediatric pain.  Upload strategies used for 4 different conditions in the ED for the conditions listed (based on national guidelines from ACEP, E-QUAL, HHS, or the CDC, for example). In addition, please upload patient education materials, DOT/SMART phrases and/or specific patient discharge instructions, if available.",
			sections: [
				{
					name: "painDocuments",
					title: ``,
					description: ``,
					questions: [
						{
							name: "level3_Pain_Management_Musculoskeletal_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Musculoskeletal_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Acute_Abdominal_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Acute_Abdominal_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}, {
							name: "level3_Pain_Management_Dental_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Dental_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Atraumatic_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Atraumatic_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Renal_Colic_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Renal_Colic_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Acute_Back_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Acute_Back_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}, {
							name: "level3_Pain_Management_Periprocedural_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Periprocedural_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Other_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Pain_Management_Other_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				}
			]
		},

		{
			step_name: "NonOpioid",
			step_title: "Non-Opioid Pharmacologic Modalities",
			step_description:
				"",
			sections: [
				{
					name: "nonOpioidModalities",
					title: `Non-Opioid Modalities`,
					description: `Standardize the use of non-opioid pharmacologic modalities from the following list.  In addition, please upload patient education materials, DOT/SMART phrases and/or specific discharge instructions created that are related to the selected modalities, if available.`,
					questions: [
						{
							name: "level3_NonOpioid_Modalities_Ketamine_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Ketamine_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Gabapentinoid_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Gabapentinoid_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}, {
							name: "level3_NonOpioid_Modalities_Patches_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Patches_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Haloperidol_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Haloperidol_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_NSAIDS_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_NSAIDS_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Lidocaine_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Lidocaine_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}, {
							name: "level3_NonOpioid_Modalities_Other_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_NonOpioid_Modalities_Other_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				}
			]
		},

		{
			step_name: "Stewardship",
			step_title: "Opioid Stewardship",
			step_description: '',
			sections: [
				{
					name: "prescribing",
					title: `Opioid Ordering and Prescribing`,
					description: `Document strategies to support opioid stewardship related to treating patients with opioids in the ED as well as prescribing opioids at discharge. Examples include minimizing the number of pills at discharge, the EHR default quantity for opioid drugs to reflect 3 days or less and minimizing the use of euphoria-inducing opioids (e.g. minimized use of IV push drugs when appropriate).`,
					questions: [
						{
							name: "level2_Stewardship_Prescribing_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				},
				{
					name: "acute",
					title: `Acute Exacerbation of Chronic Pain`,
					description: `Implement strategies for the management of acute, intermittent, or chronic pain based on best practice guidelines. Please upload different protocols, guidelines, or standardized procedures. This may include special population protocols such as geriatric pain and/or pediatric pain. In addition, please upload patient education materials, DOT phrases and/or discharge plans for the selected modalities if available.`,
					questions: [
						{
							name: "level2_Stewardship_Acute_Sickle_Cell_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Sickle_Cell_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Gastroparesis_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Gastroparesis_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}, {
							name: "level2_Stewardship_Acute_Neuropathic_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Neuropathic_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Musculoskeletal_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Musculoskeletal_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Headache_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Headache_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Other_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Acute_Other_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				}, {
					name: "naloxone",
					title: `Naloxone Prescription and Education`,
					description: `Standardize naloxone education and prescribing or dispensing for high-risk patients. Note: High-risk patients includes patients presenting after opioid or other drug overdose, history of overdose in the past, active injection drug use, or for other illicit drug use, or for pain management.`,
					questions: [
						{
							name: "level2_Stewardship_Naloxone_Prescription_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Naloxone_Education_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				},
				{
					name: "reduction",
					title: `Opioid Harm Reduction`,
					description: `Establish opioid risk reduction interventions for patients seen in the ED <span class="italics"><b>following opioid overdose</b></span>. May include order sets, protocols, or clinical process discharge information.`,
					questions: [
						{
							name: "level2_Stewardship_Reduction_Risk_Education_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Reduction_Clean_Usage_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Reduction_Health_Screenings_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Reduction_Relationship_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Reduction_Syringe_Exchange_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				},
				{
					name: "buprenorphine",
					title: `Buprenorphine`,
					description: `Implement a buprenorphine treatment program for opioid withdrawal in the ED.`,
					questions: [
						{
							name: "level2_Stewardship_Buprenorphine_Initiating_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Buprenorphine_facilities_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Buprenorphine_Transition_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Buprenorphine_Collaboration_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				},
				{
					name: "physNames",
					title: `DEA DATA 2000 Waiver`,
					description: `Upload a list of full time physicians, nurse practitioners, and physician assistants that have been DEA DATA 2000 waivered.`,
					questions: [
						{
							name: "level2_Stewardship_list_physician_total",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_physNames_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				},
				{
					name: "monitoring",
					title: `Prescription Drug Monitoring Program (PDMP)`,
					description: `Provide documentation demonstrating the use of the PDMP in accordance with state regulations.`,
					questions: [
						{
							name: "level2_Stewardship_Monitoring_PDMP_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level2_Stewardship_Monitoring_Regulations_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				},
			]
		},

		{
			step_name: "nonPharmacologic",
			step_title: "Non-Pharmacologic Pain Management Modalities",
			step_description: "Establish strategies emphasizing the use of non-pharmacologic pain management modalities in the ED. Upload any guidelines or protocols created, and any patient education materials encouraging the use of these non-pharmacologic modalities after discharge. By uploading the documents, your department is attesting to the availability and use of these modalities.",
			sections: [
				{
					name: "nonPharmPainDocuments",
					title: ``,
					description: ``,
					questions: [
						{
							name: "level3_Non_Pharmacologic_Hot_Cold_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Hot_Cold_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_TENS_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_TENS_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}, {
							name: "level3_Non_Pharmacologic_Immobilization_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Immobilization_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Imaging_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Imaging_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Manipulation_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Manipulation_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_PT_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_PT_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}, {
							name: "level3_Non_Pharmacologic_Distractions_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Distractions_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Music_Therapy_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Music_Therapy_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Aroma_Therapy_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Aroma_Therapy_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Other_Protocol_file",
							title: "",
							description: "",
							dataSet: []
						},
						{
							name: "level3_Non_Pharmacologic_Other_Protocol_Materials_file",
							title: "",
							description: "",
							dataSet: []
						}
					]
				}
			]
		},

		{
			step_name: "quality",
			step_title: "Quality Assurance/ Quality Improvement (QA/QI) Process",
			step_description: `Establish a QA/QI process surrounding opioid stewardship and alternative therapies for managing acute and chronic pain in the ED."  Criteria not confirmed by BOGs yet.`,
			sections: [
				{
					name: "qualityimp",
					title: `In general, how are outcomes reassessed
for quality improvement? How often do you / will
you review results, what kind of modifications may be considered if procedures / policies are
not accomplishing desired goals?`,
					description: "",
					questions: []
				}
			]
		}
	]
};



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/classes/cms/level3.cms.ts